/* Libs */
import create from 'zustand';

/* Model */
import FurnituresCategories from 'Models/FurnituresCategories';

const [useFurnituresCategoriesStore] = create(set => ({
	categories: null,
	fetchCategories: async () => {
		const response = await FurnituresCategories.get();
		console.log('set categories', response);

		set({ categories: response });
	}
}));

export default useFurnituresCategoriesStore;
